const CHARACTERS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*()_+ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ";
const FRAME_MS = 30;
const CHARS_PER_FRAME = 1 / 3;

const randomChar = () =>
  CHARACTERS[Math.floor(Math.random() * CHARACTERS.length)];

const toText = (value) =>
  value === undefined || value === null ? "" : String(value);

function stopAnimation(state) {
  if (state.interval) {
    clearInterval(state.interval);
    state.interval = null;
  }
}

function animate(el, state) {
  stopAnimation(state);
  const text = state.text;
  let revealed = 0;

  state.interval = setInterval(() => {
    if (revealed >= text.length) {
      stopAnimation(state);
      el.textContent = text;
      return;
    }
    el.textContent = text
      .split("")
      .map((char, index) => (index < revealed ? char : randomChar()))
      .join("");
    revealed += CHARS_PER_FRAME;
  }, FRAME_MS);
}

export default {
  mounted(el, binding) {
    const state = {
      text: toText(binding.value),
      isVisible: false,
      interval: null,
      observer: null,
    };
    el._decrypt = state;
    el.textContent = "";

    state.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          state.isVisible = true;
          state.observer.disconnect();
          state.observer = null;
          animate(el, state);
        }
      },
      { threshold: 0.1 },
    );
    state.observer.observe(el);
  },

  updated(el, binding) {
    const state = el._decrypt;
    const text = toText(binding.value);
    if (!state || text === state.text) return;

    state.text = text;
    // Před prvním zobrazením uložíme nový text
    if (state.isVisible) {
      animate(el, state);
    }
  },

  beforeUnmount(el) {
    const state = el._decrypt;
    if (!state) return;
    stopAnimation(state);
    if (state.observer) state.observer.disconnect();
    delete el._decrypt;
  },
};
